  export class NewPayemnts {
    operationState="i";
    IsRemove=false;
    idPayment=undefined;
    payMode='';
    bankName='';
    branchName='';
    ifscCode='';
    chequeNumber='';
    paidAmount=0;
    paymentDate='';      
    transactionId='';
    idBillmaster=0;
}